import { EnumOption } from './enum-option';

export const PWWageLevel = {
  NA: 0,
  I: 1,
  II: 2,
  III: 3,
  IV: 4,
  OEWSMean: 5,
};

export const PWWageLevelList: EnumOption[] = [
  { value: PWWageLevel.I, label: 'I' },
  { value: PWWageLevel.II, label: 'II' },
  { value: PWWageLevel.III, label: 'III' },
  { value: PWWageLevel.IV, label: 'IV' },
  { value: PWWageLevel.OEWSMean, label: 'OEWS Mean' },
  { value: PWWageLevel.NA, label: 'N/A' },
];
